import { playHaptic } from '../haptics';

const img = (name) => `${process.env.PUBLIC_URL}/img/${name}`;

export const TABS = [
  { id: 'players', hash: '/players', label: 'Лидерборд', icon: 'icon-users-nav.svg' },
  { id: 'games', hash: '/', label: 'Игры', icon: 'icon-controller.svg' },
  { id: 'rules', hash: '/rules', label: 'Правила', icon: 'icon-document.svg' },
];

function TabBar({ active = 'games' }) {
  const index = Math.max(0, TABS.findIndex((tab) => tab.id === active));

  return (
    <nav className="tabbar-wrap" aria-label="Навигация">
      <div className="tabbar" style={{ '--tab': index }}>
        <span className="tab-pill" aria-hidden="true" />
        {TABS.map((tab) => {
          const isActive = tab.id === active;
          return (
            <button
              key={tab.id}
              type="button"
              className={`tab${isActive ? ' active' : ''}`}
              aria-label={tab.label}
              aria-current={isActive ? 'page' : undefined}
              data-cuelume-toggle
              onClick={() => {
                if (isActive) return;
                playHaptic('selection');
                window.location.hash = tab.hash;
              }}
            >
              <img src={img(tab.icon)} alt="" draggable="false" />
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default TabBar;
